/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Section_WorkflowInputs */

const en_marketing_section_workflow = /** @type {(inputs: Marketing_Section_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow`)
};

const es_marketing_section_workflow = /** @type {(inputs: Marketing_Section_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flujo de trabajo`)
};

const fr_marketing_section_workflow = /** @type {(inputs: Marketing_Section_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow`)
};

/**
* | output |
* | --- |
* | "Workflow" |
*
* @param {Marketing_Section_WorkflowInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_section_workflow = /** @type {((inputs?: Marketing_Section_WorkflowInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Section_WorkflowInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_section_workflow(inputs)
	if (locale === "es") return es_marketing_section_workflow(inputs)
	return fr_marketing_section_workflow(inputs)
});